import React from 'react'; 

const AccountLinkage = (props) => {
     
    const {leftLabelId, leftLabelName, displayArray} = props;
  
    return(
        <div className="row around-xs inputPairPreview elementVisible">
        <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7">
            <label className="box text-left" id={leftLabelId}>{leftLabelName}</label>
        </div>
        <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
        {displayArray.map((item, idx) => (
            <div className="box" style={{ width:"100%" }} key={idx} >
            <label style={{width:"100%", fontWeight: "500", wordBreak: "break-word",float:"right", textAlign:'right'}} editorid={'serviceLinkage'+idx}>{item}</label> 
            </div>
        ))}
      
        </div>
     
        </div>
    )
 
}

export default AccountLinkage;